(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('thornvella-recommendations')) {
    customElements.define('thornvella-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.bindControls();
        if (this.hidden) {
          this.loadRecommendations();
          return;
        }
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.loadRecommendations();
          }, { rootMargin: '200px' });
          this.observer.observe(this);
        } else {
          this.loadRecommendations();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.controller?.abort();
        this.ready = false;
      }

      async loadRecommendations() {
        this.controller = new AbortController();
        try {
          const response = await fetch(this.dataset.url, { signal: this.controller.signal });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = html.querySelector('thornvella-recommendations [data-recommendations-content]');
          if (!content || !this.isConnected) return;
          if (this.contains(document.activeElement)) return;
          this.resizeObserver?.disconnect();
          this.replaceChildren(content);
          this.hidden = false;
          this.bindControls();
          document.dispatchEvent(new CustomEvent('thornvella:products-updated'));
        } catch (_) {}
      }

      bindControls() {
        const track = this.querySelector('[data-recommendations-track]');
        const controls = this.querySelector('.product-recommendations__controls');
        const previous = this.querySelector('[data-recommendations-prev]');
        const next = this.querySelector('[data-recommendations-next]');
        if (!track || !controls || !previous || !next) return;
        const update = () => {
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          controls.hidden = maximum < 2;
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maximum - 2;
        };
        const move = (direction) => {
          const first = track.firstElementChild;
          if (!first) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({ left: direction * (first.getBoundingClientRect().width + gap), behavior: reducedMotion ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('keydown', (event) => {
          if (event.target !== track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            move(event.key === 'ArrowLeft' ? -1 : 1);
          }
        });
        let scheduled = false;
        track.addEventListener('scroll', () => {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(() => { update(); scheduled = false; });
        }, { passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(update);
          this.resizeObserver.observe(track);
        }
        requestAnimationFrame(update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
